// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle.js
import { section, container, main, mainRaised, title, whiteColor } from 'styles/jss/original/base';

const styles = {
  productPage: {
    backgroundColor: whiteColor
  },
  section,
  container,
  main,
  mainRaised: {
    ...mainRaised,
    margin: '-50vh 0 0',
    padding: '40px',
    '@media (max-width: 1024px)': {
      margin: '-30vh 0 0'
    },
    '@media (max-width: 992px)': {
      margin: '-30vh 0 0'
    },
    '@media (max-width: 640px)': {
      margin: '-30vh 0 0',
      padding: '20px'
    }
  },
  title: {
    ...title,
    marginBottom: 0
  }
};

export default styles;
